<template>
  <tr>
    <td :style="`background-color: ${bgColor}; position: relative;`">

      <div v-if="id" :class="'block-wrapper ' + type + (showModal ? ' active' : '')" @dblclick="showModal = true">
        <b-dropdown
          v-if="id"
          :id="`block-menu-${id}`"
          variant="outline-primary"
          toggle-class="edit px-2 mr-3 mt-2"
          style="position: absolute; right: 0;"
          no-caret
          :disabled="isBusy || disabled"
        >
          <template #button-content>
            <i class="fa fa-fw fa-ellipsis-v"></i>
          </template>
          <b-dropdown-item @click="showModal = true">
            <i class="fa fa-fw fa-edit"></i>
            {{ trans('edit') }}
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('add-block-before', id)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('before') }}
          </b-dropdown-item>
          <b-dropdown-item @click="$emit('add-block-after', id)">
            <i class="fa fa-fw fa-plus"></i>
            {{ trans('after') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onClickDuplicate">
              <i class="fa fa-fw fa-copy"></i>
              {{ trans('duplicate') }}
          </b-dropdown-item>
          <b-dropdown-item @click="onClickDelete">
            <span class="text-danger">
              <i class="fa fa-fw fa-trash"></i>
              {{ trans('delete') }}
            </span>
          </b-dropdown-item>
        </b-dropdown>

        <hero
          v-if="saved.type == 'hero'"
          :block="saved"
        ></hero>
        <one-column
          v-if="saved.type == 'one-column'"
          :block="saved"
          :button_color="button_color"
          :button_radius="button_radius"
          :placeholders="placeholders"
        ></one-column>
        <image-column
          v-if="saved.type == 'image-column'"
          :block="saved"
          :button_color="button_color"
          :button_radius="button_radius"
          :placeholders="placeholders"
        ></image-column>
        <column-image
          v-if="saved.type == 'column-image'"
          :block="saved"
          :button_color="button_color"
          :button_radius="button_radius"
          :placeholders="placeholders"
        ></column-image>
        <spacer
          v-if="saved.type == 'spacer'"
          :block="saved"
        ></spacer>
        <two-columns
          v-if="saved.type == 'two-columns'"
          :block="saved"
          :button_color="button_color"
          :button_radius="button_radius"
          :placeholders="placeholders"
        ></two-columns>
        <video-block
          v-if="saved.type == 'video'"
          :block="saved"
        ></video-block>
        <video-column
          v-if="saved.type == 'video-column'"
          :block="saved"
          :button_color="button_color"
          :button_radius="button_radius"
          :placeholders="placeholders"
        ></video-column>
        <zoom
          v-if="saved.type == 'zoom'"
          :block="saved"
          :button_color="button_color"
          :button_radius="button_radius"
          :placeholders="placeholders"
        ></zoom>
        <paper
          v-if="saved.type == 'paper'"
          :organization="organization"
          :recipient="recipient"
          :block="saved"
          :placeholders="placeholders"
        ></paper>
      </div>

      <b-modal
        v-model="showModal"
        size="xl"
        no-close-on-backdrop
        no-enforce-focus
        no-close-on-esc
        @shown="onShown"
        @close="reset"
        @hidden="onHidden"
      >
        <template v-slot:modal-title>
          <span class="mr-4">
            {{ modalTitle }}
            <small class="text-muted" v-if="!!id">#{{ id }}</small>
          </span>
          <span v-if="id && type == 'hero'" class="text-muted">
            <i class="fa fa-fw fa-image"></i>
          </span>
          <span v-if="id && type == 'one-column'" class="text-muted">
            <i class="fa fa-fw fa-align-justify"></i>
          </span>
          <span v-if="id && type == 'image-column'" class="text-muted">
            <i class="fa fa-fw fa-image"></i>
            <i class="fa fa-fw fa-align-justify"></i>
          </span>
          <span v-if="id && type == 'column-image'" class="text-muted">
            <i class="fa fa-fw fa-align-justify"></i>
            <i class="fa fa-fw fa-image"></i>
          </span>
          <span v-if="id && type == 'spacer'" class="text-muted">
            <i class="fa fa-fw fa-grip-lines"></i>
          </span>
          <span v-if="id && type == 'two-columns'" class="text-muted">
            <i class="fa fa-fw fa-align-justify"></i>
            <i class="fa fa-fw fa-align-justify"></i>
          </span>
          <span v-if="id && type == 'image'" class="text-muted">
            <i class="fa fa-fw fa-film"></i>
          </span>
          <span v-if="id && type == 'video-column'" class="text-muted">
            <i class="fa fa-fw fa-film"></i>
            <i class="fa fa-fw fa-align-justify"></i>
          </span>
          <span v-if="id && type == 'zoom'" class="text-muted">
            <i class="fa fa-fw fa-video"></i>
          </span>
          <span v-if="id && type == 'paper'" class="text-muted">
            <i class="fa fa-fw fa-certificate"></i>
          </span>
          <small v-if="id" class="text-muted">
            {{ trans('block_'+type.replace('-', '_')) }}
          </small>
          <b-button
            v-if="!!id"
            variant="outline-secondary"
            size="sm"
            class="ml-2 py-0"
            @click="allow_switch = !allow_switch"
          >
            {{ trans('modify') }}
            <i :class="`fa fa-fw fa-chevron-${allow_switch ? 'up' : 'down'}`"></i>
          </b-button>
        </template>
        <block-tiles
          :id="id"
          :organization="organization"
          v-model="type"
          :show="!id || allow_switch"
          :tab="tab"
          @tab="tab = $event"
        ></block-tiles>

        <spacer-config
          v-if="type == 'spacer'"
          :organization="organization"
          :id="id"
          :meta="meta"
          @meta="meta = $event"
        ></spacer-config>

        <b-tabs v-model="tab" lazy class="block-options" v-if="type != 'two-columns' && type != 'spacer'">
          <b-tab :title="trans('video')" class="mt-3" v-if="isTabVisible('video')">
            <video-tab
              :organization="organization"
              :type="type"
              :image_url="image_url"
              :image_media_id="image_media_id"
              :image_alt="image_alt"
              :image_cta_url="image_cta_url"
              :image_percent="image_percent"
              :button_text="button_text"
              :button_url="button_url"
              :text="text"
              :meta="meta"
              @image_url="image_url = $event"
              @image_media_id="image_media_id = $event"
              @image_alt="image_alt = $event"
              @image_cta_url="image_cta_url = $event"
              @image_percent="image_percent = $event"
              @button_text="button_text = $event"
              @button_url="button_url = $event"
              @text="text = $event"
              @meta="meta = $event"
            ></video-tab>
          </b-tab>

          <b-tab title="Zoom" class="mt-3" v-if="isTabVisible('zoom')">
            <zoom-tab
              :organization="organization"
              :type="type"
              :image_url="image_url"
              :image_media_id="image_media_id"
              :image_alt="image_alt"
              :image_cta_url="image_cta_url"
              :image_percent="image_percent"
              :button_text="button_text"
              :button_url="button_url"
              :text="text"
              @image_url="image_url = $event"
              @image_media_id="image_media_id = $event"
              @image_alt="image_alt = $event"
              @image_cta_url="image_cta_url = $event"
              @image_percent="image_percent = $event"
              @button_text="button_text = $event"
              @button_url="button_url = $event"
              @text="text = $event"
            ></zoom-tab>
          </b-tab>

          <b-tab :title="trans('paper')" class="mt-3" v-if="isTabVisible('paper')">
            <b-row>
              <b-col>
                <papers-dropdown
                  :organization="organization"
                  v-model="paper_id"
                  nullable
                  @paper="onChoosePaper($event)"
                ></papers-dropdown>
                <small v-if="!!paper_id" class="d-block text-right">
                  <b-link :href="`/organization/${organization.id}/paper/${paper_id}`" target="_blank">
                    {{ trans('design') }}
                    <i class="fa fa-fw fa-external-link-alt"></i>
                  </b-link>
                </small>
                <small class="d-block mt-3 text-muted">
                  <i class="fa fa-fw fa-info-circle"></i>
                  {{ trans('paper_about') }}
                  <b-button variant="link" size="sm" class="py-0" :href="`/organization/${organization.id}/paper`" target="_blank">
                    {{ trans('paper') }}
                    <i class="fa fa-fw fa-external-link-alt"></i>
                  </b-button>
                </small>
              </b-col>
              <b-col class="text-center align-self-center">
                <b-img fluid :src="!!paper_id && !!image_url ? image_url : '/img/frontend/blocks/1200x600.png'" />
              </b-col>
            </b-row>
          </b-tab>

          <b-tab :title="trans('text')" class="mt-3" v-if="isTabVisible('text') && type != 'image-column'">
            <html-textarea
              :organization="organization"
              :placeholders="editor_placeholders"
              show-insert-form-document
              hide-highlight-heading
              v-model="text"
            ></html-textarea>
          </b-tab>

          <b-tab :title="trans('image')" class="mt-3" v-if="isTabVisible('image')">
            <image-tab
              :organization="organization"
              :type="type"
              :image_url="image_url"
              :image_media_id="image_media_id"
              :image_alt="image_alt"
              :image_cta_url="image_cta_url"
              :image_percent="image_percent"
              :image_pexels="image_pexels"
              :meta="meta"
              hide-align
              hide-image-percent
              @image_url="image_url = $event"
              @image_media_id="image_media_id = $event"
              @image_alt="image_alt = $event"
              @image_cta_url="image_cta_url = $event"
              @image_percent="image_percent = $event"
              @image_pexels="image_pexels = $event"
              @meta="meta = $event"
            ></image-tab>
          </b-tab>

          <b-tab :title="trans('text')" class="mt-3" v-if="isTabVisible('text') && type == 'image-column'">
            <html-textarea
              :organization="organization"
              :placeholders="editor_placeholders"
              show-insert-form-document
              hide-highlight-heading
              v-model="text"
            ></html-textarea>
          </b-tab>

          <b-tab :title="trans('button')" class="mt-3" v-if="isTabVisible('button')">
            <button-tab
              :organization="organization"
              :button_text="button_text"
              :button_url="button_url"
              show-i-calendar
              show-pay-invoice
              @button_text="button_text = $event"
              @button_url="button_url = $event"
            />
          </b-tab>

          <b-tab :title="trans('background')" class="mt-3" v-if="isTabVisible('background')">
            <BackgroundTab
              :organization="organization"
              :type="type"
              v-model="backgroundColor"
              :template="template"
            />
          </b-tab>
        </b-tabs>

        <b-row v-if="type == 'two-columns'">
          <b-col class="col-md-6">
            <b-row>
              <b-col>
                <b-form-group :label="trans('put_image_bottom')">
                  <b-form-checkbox v-model="put_image_bottom" switch>{{ trans(put_image_bottom ? 'yes' : 'no') }}</b-form-checkbox>
                </b-form-group>
              </b-col>
              <b-col>
                <BackgroundTab
                  :organization="organization"
                  :type="type"
                  v-model="backgroundColor"
                  :template="template"
                />
              </b-col>
            </b-row>
          </b-col>
        </b-row>

        <b-row cols="2" v-if="type == 'two-columns'">
          <b-col>
            <b-tabs lazy class="block-options">
              <b-tab :title="trans('image')" class="mt-3" v-if="isTabVisible('image1')">
                <image-tab
                  :organization="organization"
                  :type="type"
                  :image_url="image_url"
                  :image_media_id="image_media_id"
                  :image_alt="image_alt"
                  :image_cta_url="image_cta_url"
                  :image_percent="image_percent"
                  :image_pexels="image_pexels"
                  show-clear
                  hide-image-percent
                  @image_url="image_url = $event"
                  @image_media_id="image_media_id = $event"
                  @image_alt="image_alt = $event"
                  @image_cta_url="image_cta_url = $event"
                  @image_percent="image_percent = $event"
                  @image_pexels="image_pexels = $event"
                ></image-tab>
              </b-tab>

              <b-tab :title="trans('text')" class="mt-3" v-if="isTabVisible('text1')">
                <html-textarea
                  :organization="organization"
                  :placeholders="editor_placeholders"
                  show-insert-form-document
                  hide-highlight-heading
                  v-model="text"
                ></html-textarea>
              </b-tab>

              <b-tab :title="trans('button')" class="mt-3" v-if="isTabVisible('button1')">
                <button-tab
                  :organization="organization"
                  :button_text="button_text"
                  :button_url="button_url"
                  show-i-calendar
                  show-pay-invoice
                  @button_text="button_text = $event"
                  @button_url="button_url = $event"
                />
              </b-tab>

            </b-tabs>
          </b-col>
          <b-col>
            <b-tabs lazy class="block-options">
              <b-tab :title="trans('image')" class="mt-3" v-if="isTabVisible('image2')">
                <image-tab
                  :organization="organization"
                  :type="type"
                  :image_url="image_url2"
                  :image_media_id="image_media_id2"
                  :image_alt="image_alt2"
                  :image_cta_url="image_cta_url2"
                  :image_percent="image_percent2"
                  :image_pexels="image_pexels2"
                  show-clear
                  hide-image-percent
                  @image_url="image_url2 = $event"
                  @image_media_id="image_media_id2 = $event"
                  @image_alt="image_alt2 = $event"
                  @image_cta_url="image_cta_url2 = $event"
                  @image_percent="image_percent2 = $event"
                  @image_pexels="image_pexels2 = $event"
                ></image-tab>
              </b-tab>

              <b-tab :title="trans('text')" class="mt-3" v-if="isTabVisible('text2')">
                <html-textarea
                  :organization="organization"
                  :placeholders="editor_placeholders"
                  show-insert-form-document
                  hide-highlight-heading
                  v-model="text2"
                ></html-textarea>
              </b-tab>

              <b-tab :title="trans('button')" class="mt-3" v-if="isTabVisible('button2')">
                <button-tab
                  :organization="organization"
                  :button_text="button_text2"
                  :button_url="button_url2"
                  :showICalendar="true"
                  @button_text="button_text2 = $event"
                  @button_url="button_url2 = $event"
                />
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>

        <template v-slot:modal-footer>
          <div class="clearfix w-100">
            <delete-button v-if="id" variant="outline-danger" @confirm="onDelete" class="float-left" :disabled="isBusy">
              <i class="fa fa-fw fa-trash"></i>
            </delete-button>
            <b-button variant="primary" @click="onSave" class="float-right" :disabled="isBusy">
              {{ trans('save') }}
            </b-button>
            <b-button variant="outline-secondary" @click="onCancel" class="float-right mr-2" :disabled="isBusy">
              {{ trans('cancel') }}
            </b-button>
          </div>
        </template>

      </b-modal>
    </td>
  </tr>
</template>

<script>
  import BlockTiles from './BlockTiles'
  import DeleteButton from './../../../common/components/DeleteConfirmButton'
  import HtmlTextarea from './../../../common/components/HtmlTextarea'
  import Hero from './../blocks/Hero'
  import OneColumn from './../blocks/OneColumn'
  import ImageColumn from './../blocks/ImageColumn'
  import ColumnImage from './../blocks/ColumnImage'
  import TwoColumns from './../blocks/TwoColumns'
  import Spacer from './../blocks/Spacer'
  import VideoBlock from './../blocks/Video'
  import VideoColumn from './../blocks/VideoColumn'
  import Zoom from './../blocks/Zoom'
  import Paper from './../blocks/Paper'

  import ImageTab from './BlockImageTabComponent'
  import VideoTab from './BlockVideoTabComponent'
  import ZoomTab from './BlockZoomTabComponent'
  import ButtonTab from './BlockButtonTabComponent'
  import SpacerConfig from './BlockSpacerConfigComponent'
  import PapersDropdown from './../paper/PapersDropdown'
  import BackgroundTab from './BlockBackgroundTabComponent'

  export default {
    props: {
      organization: Object,
      template: Object,
      recipient: Object,
      block: Object,
      placeholders: Object,
      button_color: String,
      button_radius: Number,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      BlockTiles,
      DeleteButton,
      Hero,
      OneColumn,
      ImageColumn,
      ColumnImage,
      TwoColumns,
      Spacer,
      VideoBlock,
      VideoColumn,
      Zoom,
      Paper,
      HtmlTextarea,
      ImageTab,
      VideoTab,
      ZoomTab,
      ButtonTab,
      SpacerConfig,
      PapersDropdown,
      BackgroundTab,
    },
    data() {
      return {
        trans: trans,
        omit: _.omit,
        isBusy: false,
        error: null,
        showModal: false,
        types: [{
          text: trans('block_hero'),
          value: 'hero'
        }, {
          text: trans('block_one_column'),
          value: 'one-column'
        }, {
          text: trans('block_image_column'),
          value: 'image-column'
        }, {
          text: trans('block_column_image'),
          value: 'column-image'
        }, {
          text: trans('block_two_columns'),
          value: 'two-columns'
        }, {
          text: trans('block_spacer'),
          value: 'spacer'
        }, {
          text: trans('block_video'),
          value: 'video'
        }, {
          text: trans('block_video_column'),
          value: 'video-column'
        }, {
          text: trans('block_zoom'),
          value: 'zoom'
        }, {
          text: trans('paper'),
          value: 'paper'
        }],
        id: this.block.id || null,
        tab: 0,
        type: this.block.type || 'hero',
        text: this.block.text || '',
        image_url: this.block.image_url || null,
        image_media_id: this.block.image_media_id || null,
        image_alt: this.block.image_alt || null,
        image_cta_url: this.block.image_cta_url || null,
        image_percent: this.block.image_percent || 0.5,
        image_pexels: this.block.image_pexels || null,
        button_url: this.block.button_url || null,
        button_text: this.block.button_text || null,
        text2: this.block.text2 || '',
        image_url2: this.block.image_url2 || null,
        image_media_id2: this.block.image_media_id2 || null,
        image_alt2: this.block.image_alt2 || null,
        image_cta_url2: this.block.image_cta_url2 || null,
        image_percent2: this.block.image_percent2 || 0.3333,
        image_pexels2: this.block.image_pexels2 || null,
        button_url2: this.block.button_url2 || null,
        button_text2: this.block.button_text2 || null,
        meta: (this.block.meta && !Array.isArray(this.block.meta)) ? _.cloneDeep(this.block.meta) : {},
        saved: this.block,
        allow_switch: false,
        // image file upload
        image_file: null,
        image_file2: null,
        editor_placeholders: _.getGroupedPlaceholders(),
        paper_id: this.block.paper_id || null,
        put_image_bottom: this.block?.meta?.put_image_bottom || false,
        backgroundColor: this.block?.meta?.backgroundColor || this.template.content_background_color || '#ffffff',
      }
    },
    computed: {
      visibleTabs() {
        switch (this.type) {
          case 'hero':
            return ['image']
          case 'one-column':
            return ['text', 'button', 'background']
          case 'image-column':
          case 'column-image':
            return ['text', 'button', 'image', 'background']
          case 'two-columns':
            return ['text1', 'image1', 'button1', 'text2', 'image2', 'button2']
          case 'spacer':
            return []
          case 'video':
          case 'video-column':
            return ['video']
          case 'zoom':
            return ['zoom']
          case 'paper':
            return ['paper']
        }
        return []
      },
      modalId() {
        return this.id ? `block-${this.id}` : 'block-new'
      },
      modalTitle() {
        return trans((this.id ? 'edit' : 'new')+'_block')
      },
      ajaxUrl() {
      	let url = '/organization/' + this.organization.id + '/template/' + this.template.id + '/blocks'
      	if (this.id) url += '/' + this.id
      	return url
      },
      bgColor() {
        return this.block?.meta?.backgroundColor || this.template.content_background_color || '#ffffff'
      }
    },
    watch: {
      type(newType, oldType) {
        if (['zoom', 'video-column', 'video'].indexOf(oldType) >= 0) {
          this.reset()
          this.type = newType
        }
      },
    },
    methods: {
      onShown() {
        this.tab = this.block.type == 'one-column' &&
          !this.text &&
          !!this.button_url ? 1 : 0
      },
      onHidden() {
        this.allow_switch = false
      },
      onChoosePaper(paper) {
        this.image_url = !!paper && !!paper.preview_media ? paper.preview_media.url : null
        this.image_media_id = !!paper && !!paper.preview_media ? paper.preview_media.id : null
      },
      isTabVisible(tab) {
        return this.visibleTabs.indexOf(tab) >= 0
      },
      serialize() {
        let meta = this.meta || {}

        if (this.backgroundColor) {
          meta.backgroundColor = this.backgroundColor
        } else {
          delete meta.backgroundColor
        }
        
        if (this.put_image_bottom) {
          meta.put_image_bottom = this.put_image_bottom
        } else {
          delete meta.put_image_bottom
        }
        
        return {
          id: this.id,
          type: this.type,
          text: this.text || null,
          image_url: this.image_url,
          image_media_id: this.image_media_id,
          image_alt: this.image_alt,
          image_cta_url: this.image_cta_url,
          image_percent: this.image_percent,
          image_pexels: this.image_pexels,
          button_url: this.button_url,
          button_text: this.button_text,
          text2: this.text2 || null,
          image_url2: this.image_url2,
          image_media_id2: this.image_media_id2,
          image_alt2: this.image_alt2,
          image_cta_url2: this.image_cta_url2,
          image_percent2: this.image_percent2,
          image_pexels2: this.image_pexels2,
          button_url2: this.button_url2,
          button_text2: this.button_text2,
          paper_id: this.paper_id,
          meta: meta,
        }
      },
      clear() {
        this.text = this.text2 = ''
        this.image_url = this.image_media_id = this.image_alt = this.image_cta_url = this.button_url = this.button_text = this.image_url2 = this.image_media_id2 = this.image_alt2 = this.image_cta_url2 = this.button_url2 = this.button_text2 = this.meta = this.paper_id = null
      },
      reset() {
        this.tab = 0
        this.id = this.block.id || null
        this.type = this.block.type || 'hero'
        this.text = this.block.text || ''
        this.image_url = this.block.image_url || null
        this.image_media_id = this.block.image_media_id || null
        this.image_alt = this.block.image_alt || null
        this.image_cta_url = this.block.image_cta_url || null
        this.image_percent = this.block.image_percent || 0.3333
        this.image_pexels = this.block.image_pexels || null
        this.button_url = this.block.button_url || null
        this.button_text = this.block.button_text || null
        this.text2 = this.block.text2 || ''
        this.image_url2 = this.block.image_url2 || null
        this.image_media_id2 = this.block.image_media_id2 || null
        this.image_alt2 = this.block.image_alt2 || null
        this.image_cta_url2 = this.block.image_cta_url2 || null
        this.image_percent2 = this.block.image_percent2 || 0.6666
        this.image_pexels2 = this.block.image_pexels2 || null
        this.button_url2 = this.block.button_url2 || null
        this.button_text2 = this.block.button_text2 || null
        this.paper_id = this.block.paper_id || null
        
        let meta = (this.block.meta && !Array.isArray(this.block.meta)) ? _.cloneDeep(this.block.meta) : {}
        this.backgroundColor = meta.backgroundColor || this.template.content_background_color || '#ffffff'
        this.put_image_bottom = meta.put_image_bottom || false
      },
      onCancel() {
        this.reset()
        this.showModal = false
      },
      onSave() {
      	const method = this.id ? 'patch' : 'post'
        const data = this.serialize()
        this.isBusy = true
        this.error = null
        axios[method](this.ajaxUrl, data)
        .then(response => {
          this.isBusy = false
          this.$emit('change-block', response.data)
          if (this.id) {
            this.saved = response.data
          } else {
            this.clear()
          }
          this.showModal = false
        })
        .catch(this.handleError)
      },
      onClickDuplicate() {
        this.isBusy = true
        this.error = null
        const url = `/organization/${this.organization.id}/template/${this.template.id}/blocks`
        const duplicate = _.omit(this.serialize(), 'id')
        axios.post(url, duplicate)
        .then(response => {
          this.isBusy = false
          this.$emit('duplicate', response.data)
          this.showModal = false
        })
        .catch(this.handleError)
      },
      onClickDelete() {
        this.$bvModal.msgBoxConfirm(trans('delete_confirm'), {
          title: trans('delete'),
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: trans('delete'),
          cancelTitle: trans('cancel'),
        })
        .then(value => {
          if (value) this.onDelete()
        })
      },
      onDelete() {
        this.isBusy = true
        this.error = null
        axios.delete(this.ajaxUrl)
        .then(response => {
          this.isBusy = false
          this.$emit('delete-block')
          this.showModal = false
        })
        .catch(this.handleError)
      },
      handleError(error) {
        this.isBusy = false
        this.error = _.errorFromAjax(error)
        this.$bvToast.toast(this.error, {
          title: trans('error'),
          variant: 'danger',
          solid: true,
        })
      },
    },
    mounted() {
      window['blockEdit'+(this.block.id||'')] = this
      //console.log(this.editor.builtinPlugins.map( plugin => plugin.pluginName ));
    },
  }
</script>